/*
 * File: Api.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Patient endpoints used throughout patients and other areas
 */
import { Http } from "api/Http";
import PatientModel from "../demographics/patient_info/store/DemographicsModel";
const Api = new Http("patients/1/patient");

class PatientApi {
  api: Http;
  constructor(api: Http) {
    this.api = api;
  }

  find = async (patientId: number) => {
    const res = await this.api.get("/" + patientId);
    if (res.data) {
      return PatientModel.create(res.data);
    } else {
      return null;
    }
  };

  referrals = async (patientId: number) => {
    const res = await this.api.get("/" + patientId + "/referrals");
    return res.data || [];
  };

  incidents = async (patientId: number) => {
    const res = await this.api.get("/" + patientId + "/incidents");
    return res.data || [];
  };

  currentIncidents = async (patientId: number) => {
    const res = await this.api.get("/" + patientId + "/incidents/current");
    return res.data || [];
  };
}

const newApi = new PatientApi(Api);
export default newApi;
